import { normalizeBusinessStorageId } from './sharedCore';
import { getCashRegisterRepository } from '../app/di/container';

/** Kassenjournal-Kontext — identisch für Session-Manager, Logout und Écart-Modal. */
export function getCashRegisterOutflowContextForBusiness(businessId) {
  try {
    const bid = normalizeBusinessStorageId(businessId);
    if (!bid) {
      return { businessId: null, registerSessions: [], activeRegisterSession: null };
    }
    const repo = getCashRegisterRepository();
    const registerData = repo.getRegisterData(bid);
    const registerSessions = Array.isArray(registerData?.sessions)
      ? registerData.sessions
      : repo.getSessionHistory(bid, 500) || [];
    return {
      businessId: bid,
      registerSessions,
      activeRegisterSession: registerData?.activeSession || repo.getActiveSession(bid) || null
    };
  } catch {
    return { businessId: null, registerSessions: [], activeRegisterSession: null };
  }
}
